/**
 * CRS邀请单优惠券
 *
 */
import React, { useImperativeHandle, useRef, useState } from 'react';
import { Modal, Spin, Tabs, Form, message } from 'antd';
import styles from '@/components/SelectDiscountCoupon/index.module.scss';
import { renderIntlLabel } from '@/utils';

import WYCouponList, { ICouponItem } from './WYCouponList';

interface ISelectorConfig {
  hotelCouponList: any; // 券列表
  couponNum: number; // 可选券类型
  memberInfo?: any; // 用户信息
  callback?: (value: string[], record?: Partial<ICouponItem>[]) => void;
}

export interface CouponSelectorRef {
  openModal?: (value: ISelectorConfig) => void;
  closeModal?: () => void;
  onConfirm?: (value: any, data: any) => void;
}

const SelectDiscountCoupon: React.FC<any> = ({ onConfirm, myRef }) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [isModalLoading, setModalLoading] = useState<boolean>(false);
  const [couponNum, setCouponNum] = useState<number>(0);
  const [couponList, setCouponList] = useState<any[]>([]);
  const [userInfo, setUserInfo] = useState<any>({});
  const [customerInfo, setCustomerInfo] = useState<
    Partial<{
      name: string;
      custNo: string;
      mobile: string;
    }>
  >({});
  // 选券入参
  const selectorConfigRef = useRef<ISelectorConfig>();

  // 获取配置
  const getSelectorConfig = () => {
    return selectorConfigRef.current || ({} as ISelectorConfig);
  };

  // 初始化网鱼券列表
  // const initWYCouponList = async () => {
  //   setModalLoading(true);
  //   const listData = await getWYCouponList();
  //   const { changedCouponId, lockCouponList, unlockCouponList } = getSelectorConfig();
  //   updateWYCouponList({
  //     list: listData,
  //     selectCouponList: changedCouponId,
  //     lockCouponList,
  //     unlockCouponList,
  //   });
  //   setModalLoading(false);
  // };

  // 关闭弹框
  const closeModal = () => {
    setModalVisible(false);
  };

  // ref
  useImperativeHandle(
    myRef,
    () => ({
      openModal: (data) => {
        // console.log(data, 'hotelCouponList');
        setModalVisible(true);
        setCouponList(data.hotelCouponList);
        setCouponNum(data.couponNum);
        setUserInfo(data.memberInfo);
      },
      closeModal,
    }),
    [],
  );

  // 确认操作
  const handleOk = () => {
    // onConfirm
    const newCoupon = [];
    // console.log(couponList, 'couponList');
    couponList.forEach((val) => {
      if (val.isChecked) {
        // console.log(val.couponNo, 'couponNo');
        newCoupon.push(val.couponNo);
      }
    });
    // console.log(newCoupon, 'newCoupon');
    // console.log(onConfirm, 'onConfirm');
    onConfirm(newCoupon, couponList);
    setModalVisible(false);
    // console.log(couponList, 'couponList');
  };

  // 网鱼券选中回调
  const handleSelect = (couponNo) => {
    // console.log(couponNo, 'couponNo');
    const newCouponList = [];
    const selectCoupon = couponList.filter((item) => item.isChecked);
    const isSelectInd = couponList.findIndex(
      (item) => item.couponNo === couponNo && item.isChecked,
    );
    // console.log(couponNum, selectCoupon.length, isSelectInd, 'selectCouponNum');
    if (isSelectInd !== -1 || selectCoupon.length < couponNum) {
      couponList.forEach((val) => {
        if (val.couponNo === couponNo) {
          newCouponList.push({
            ...val,
            isChecked: !val.isChecked,
          });
        } else {
          newCouponList.push({
            ...val,
          });
        }
      });
      setCouponList(newCouponList);
    } else {
      message.error(renderIntlLabel('order_crs_msg_reach_avalible_limit'));
    }
  };

  const selectorConfigValue = getSelectorConfig();
  // const selectorConfigValue = getSelectorConfig();

  const getCertNo = (data) => {
    if (data) {
      const reg = /^(.{4})(?:\d+)(.{4})$/;
      const newData = data.replace(reg, '$1**********$2');
      return newData;
    }
    return '';
  };

  const getGuestPhone = (data) => {
    if (data) {
      const reg = /^(.{3})(?:\d+)(.{4})$/;
      const newData = data.replace(reg, '$1****$2');
      return newData;
    }
    return '';
  };

  return (
    <Modal
      wrapClassName={styles.container}
      title={renderIntlLabel('guest_title_select_of_coupon')}
      destroyOnClose
      maskClosable={false}
      visible={modalVisible}
      onOk={handleOk}
      confirmLoading={isModalLoading}
      onCancel={closeModal}
    >
      <div className={styles.info}>
        <Form.Item label={renderIntlLabel('order_roomorder_name')}>{userInfo?.guestName}</Form.Item>
        <Form.Item label={renderIntlLabel('order_roomorder_cert_no')}>
          {getCertNo(userInfo?.custNo)}
        </Form.Item>
        <Form.Item label={renderIntlLabel('order_roomorder_mobile')}>
          {getGuestPhone(userInfo?.guestPhone)}
        </Form.Item>
      </div>
      <Spin spinning={isModalLoading}>
        <WYCouponList handleSelect={handleSelect} couponList={couponList} />
      </Spin>
    </Modal>
  );
};

export default React.forwardRef<any, CouponSelectorRef>((props, ref) => (
  <SelectDiscountCoupon {...props} myRef={ref} />
));
